
export class NurseAssessmentModel{
patientcode = '' ;
visitdate ='2024-01-01' ;
nursetime ='2024-01-01';
visitlocation = '' ;
weight = '' ;
height = '' ;
pressure = '' ;
pulse = '' ;
temp = '' ;
nursenote = '' ;
paconsent = '';
userid =''
}
export class NurseFollowUpModel{
  prepmasterid = '' ;
  category = '' ;
  prepimportant = '' ;
  starttieme = '2024-01-01' ;
  endtime = '2024-01-01' ;
  notes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;

}
